import React from 'react';
import './ProfilCard.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import userNeutralIcon from '../content/functionalpagelogin/images/user_neutral.png';

import AvatarPreview from
  '../content/functionalpagelogin/leftSidebar/pages/profile/avatar/AvatarPreview';

import {
  getAvatarAsset
} from '../content/functionalpagelogin/leftSidebar/pages/profile/avatar/avatarConfig';



const SOCIAL_PROVIDER_NAMES = { google: 'Google', linkedin: 'LinkedIn' };

const ProfilCard = ({
  userData,
  onProfileSave,
  username,
  onUsernameChange,
  nickname,
  onNicknameChange,
  currentPassword,
  onCurrentPasswordChange,
  newPassword,
  onNewPasswordChange,
  successMessage,
  messageType = 'success',
  onEditAvatar
}) => {
  // Conturile create cu Google / LinkedIn n-au parolă ContaLearn (serverul refuză schimbarea).
  // Cât timp profilul nu s-a încărcat (has_password lipsește) nu arătăm nici câmpurile, nici nota.
  const hasPassword = userData?.has_password === true;
  const isSocialAccount = userData?.has_password === false;
  const providerName = SOCIAL_PROVIDER_NAMES[userData?.auth_provider];

  return (
    <div className='profil-card'>
      {/* Titlu vizibil pe toate rezolutiile */}
      <h4 className='profil-card__desktop-title'>Profil</h4>
      {/* Titlu vizibil doar pe mobil */}
    
  <div className="profil-card__picture-section">
  <div className="profil-card__picture-wrapper">

    <div className="profil-card__picture-container">
      {userData?.avatar_config ? (
        <AvatarPreview
          avatar={userData.avatar_config}
        />
      ) : (
        <img
          src={userData?.profile_picture || userNeutralIcon}
          alt="Avatar utilizator"
          className="profil-card__picture-img"
        />
      )}
    </div>

    <button
      type="button"
      className="profil-card__avatar-edit"
      onClick={onEditAvatar}
      aria-label="Editeaza avatarul"
      title="Editeaza avatarul"
    >
      <FontAwesomeIcon icon={faPen} />
    </button>

  </div>
</div>
    <form className='profil-card__form' onSubmit={onProfileSave}>



{/* USERNAME */}
<div className='profil-card__form-group'>
  <label
    className='profil-card__form-label'
    htmlFor='profil-card-nickname'
  >
    Username
  </label>

  <input
    id='profil-card-nickname'
    type='text'
    className='profil-card__form-input'
    value={nickname || ''}
    onChange={e => onNicknameChange?.(e.target.value)}
    placeholder='Introdu un username'
    maxLength={30}
    autoComplete='nickname'
  />

  <small className='profil-card__form-hint'>
    Username-ul va fi afisat in clasament.
  </small>
</div>



{/* NUME SI PRENUME */}
<div className='profil-card__form-group'>
  <label className='profil-card__form-label'>
    Nume si prenume
  </label>

  <input
    type="text"
    className='profil-card__form-input'
    value={username !== undefined ? username : (userData?.username || '')}
    onChange={e => onUsernameChange && onUsernameChange(e.target.value)}
    placeholder="Introdu numele si prenumele"
  />

  <small className='profil-card__form-hint'>
    Numele si prenumele vor fi afisate pe diploma.
  </small>
</div>

 

  

  {/* EMAIL */}
  <div className='profil-card__form-group'>
    <label className='profil-card__form-label'>
      E-mail
    </label>

    <input
      type="email"
      className='profil-card__form-input'
      value={userData?.email || ''}
      disabled
    />
  </div>

  {hasPassword && (
    <>
      {/* PAROLA CURENTA */}
      <div className='profil-card__form-group'>
        <label className='profil-card__form-label' htmlFor='profil-card-current-password'>
          Parola curentă
        </label>

        <input
          id='profil-card-current-password'
          type="password"
          className='profil-card__form-input'
          value={currentPassword || ''}
          onChange={e => onCurrentPasswordChange?.(e.target.value)}
          autoComplete='current-password'
        />
      </div>

      {/* PAROLA NOUA */}
      <div className='profil-card__form-group'>
        <label className='profil-card__form-label' htmlFor='profil-card-new-password'>
          Parola nouă
        </label>

        <input
          id='profil-card-new-password'
          type="password"
          className='profil-card__form-input'
          value={newPassword || ''}
          onChange={e => onNewPasswordChange?.(e.target.value)}
          autoComplete='new-password'
        />

        <small className='profil-card__form-hint'>
          Completează câmpurile doar dacă vrei să schimbi parola (minim 8 caractere).
        </small>
      </div>
    </>
  )}

  {isSocialAccount && (
    <div className='profil-card__form-group'>
      <span className='profil-card__form-label'>Parola</span>
      <p className='profil-card__social-note'>
        {providerName
          ? `Te conectezi cu ${providerName}, așa că contul tău nu are o parolă ContaLearn de schimbat. Parola o gestionezi din contul ${providerName}.`
          : 'Te conectezi printr-un cont social, așa că contul tău nu are o parolă ContaLearn de schimbat.'}
      </p>
    </div>
  )}

  <button
    type="submit"
    className='profil-card__btn-save-profile'
  >
    <span>SALVEAZA MODIFICARILE</span>
  </button>

  {/* Rezultatul salvarii (succes sau mesajul de validare de la server) */}
  {successMessage && (
    <div
      className={messageType === 'error' ? 'profil-card__alert-error' : 'profil-card__alert-success'}
      role={messageType === 'error' ? 'alert' : 'status'}
    >
      {successMessage}
    </div>
  )}

</form>
    </div>
  );
};

export default ProfilCard;
